import { Component } from 'react';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import DataGrid from 'components/DataGrid/DataGrid';
import { isEmpty, isGranted } from 'helpers/helpers';
import {
  ROLE_CREATE_IMPORTER_TASK,
  ROLE_SHOW_IMPORTER_TASK,
  ROLE_CREATE_USER,
  ROLE_IMPERSONATE_USER,
  ROLE_IMPORT_USER,
  ROLE_REMOVE_USER,
} from 'helpers/roles';
import Button from 'components/CustomButtons/Button';
import InfoModal from 'components/InfoModal/InfoModal';
import MediaUpload from 'components/MediaUpload/MediaUpload';
// eslint-disable-next-line import/order -- FIXME
import FakeUserIcon from 'components/FakeUserIcon/FakeUserIcon';

import gastro from 'helpers/gastro';
import { get, post } from 'helpers/apiHelpers';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchBrandsList } from 'actions/Brands';
import { fetchSexes } from 'actions/Dictionary';
import { fetchUsers } from 'actions/Users';
import { withTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';
import SweetAlert from 'react-bootstrap-sweetalert';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { remove } from 'helpers/apiHelpers';
import moment from 'moment';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import axios from 'helpers/gastro';
import { toast } from 'react-toastify';
// eslint-disable-next-line no-duplicate-imports, import/order -- FIXME
import { Trans } from 'react-i18next';
import moneyboxCSVExampleFI from './import-points-example-fi.xlsx';
import moneyboxCSVExampleEN from './import-points-example-en.xlsx';
import moneyboxCSVExample from './import-points-example.xlsx';
import importCSVExampleConsentSplitEN from './import-csv-example-consent-split-en.csv';
import importCSVExampleConsentSplitFI from './import-csv-example-consent-split-fi.csv';
import importCSVExampleConsentSplit from './import-csv-example-consent-split.csv';
import translateColumnConfig from './columnConfig';

const getExampleImportFile = language => {
  switch (language) {
    case 'fi':
      return importCSVExampleConsentSplitFI;
    case 'en':
      return importCSVExampleConsentSplitEN;
    default:
      return importCSVExampleConsentSplit;
  }
};

class List extends Component {
  state = {
    openedModal: false,
    file: null,
    isImporting: false,
    importButtonClicked: false,
    showMoneyboxModal: false,
    moneyboxFile: null,
    deleteAllCheckedClients: false,
    checkedRowIds: [],
    isConfirmModalOpened: false,
    refreshList: false,
    dishesWithIngredient: [],
    clientTags: [],
    exporting: false,
    isSmsConsentActive: false,
    isEmailConsentActive: false,
    isPhoneConsentActive: false,
  };

  componentDidMount() {
    this.props.fetchBrandsList();
    this.props.fetchSexes();
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('/sms-client-tags').then(res =>
      this.setState({ clientTags: res['hydra:member'] })
    );

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('/brand-terms').then(({ 'hydra:member': brandTerms }) => {
      this.setState({
        isSmsConsentActive:
          brandTerms.find(term => term.type === 'SMS')?.active || false,
        isEmailConsentActive:
          brandTerms.find(term => term.type === 'EMAIL')?.active || false,
        isPhoneConsentActive:
          brandTerms.find(term => term.type === 'PHONE')?.active || false,
      });
    });
  }

  refreshList = () => {
    this.setState(prevState => ({
      ...prevState,
      refreshList: !prevState.refreshList,
    }));
  };

  massDeleteHandleMultipleCheckboxes = array => {
    this.setState(prevState => ({ ...prevState, checkedRowIds: array }));
  };

  massDeleteHandleSingleCheckbox = id => {
    const checkedIdsUpdated = [...this.state.checkedRowIds];
    const checkedIdIndex = checkedIdsUpdated.indexOf(id);
    if (checkedIdIndex >= 0) {
      checkedIdsUpdated.splice(checkedIdIndex, 1);
    } else {
      checkedIdsUpdated.push(id);
    }
    this.setState(prevState => ({
      ...prevState,
      checkedRowIds: checkedIdsUpdated,
    }));
  };

  massDeleteSubmit = () => {
    this.setState(prevState => ({
      ...prevState,
      isConfirmModalOpened: false,
      isDeleting: false,
    }));

    let url = '/clients?';
    this.state.checkedRowIds.forEach((id, index) => {
      if (index === 0) {
        url = url.concat(`id[]=${id}`);
      } else {
        url = url.concat(`&id[]=${id}`);
      }
    });
    url = url.concat('&removeAllAction=true');
    remove(url)
      // eslint-disable-next-line promise/prefer-await-to-then, @typescript-eslint/no-unused-vars -- FIXME
      .then(res => {
        if (this.state.deleteAllCheckedClients) {
          toast.success(this.props.t('dictionary.massdelete.success'));
        } else {
          toast.warning(this.props.t('clients.massdelete.warning'));
        }

        this.setState(prevState => ({
          ...prevState,
          deleteAllCheckedClients: false,
          checkedRowIds: [],
        }));
        this.refreshList();
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        toast.error(this.props.t('dictionary.massdelete.error'));
      });
  };

  newSize = () => this.props.history.push(`${window.location.pathname}/add`);

  toggleModal = () => {
    this.setState(prevState => ({
      openedModal: !prevState.openedModal,
    }));
  };

  toggleMoneyboxModal = () => {
    this.setState(prevState => ({
      showMoneyboxModal: !prevState.showMoneyboxModal,
    }));
  };

  importClients = () => {
    this.setState({ importButtonClicked: true });
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    this.uploadFile(this.state.file).then(file => {
      this.postImporterTask(file);
    });
  };

  importMoneyboxState = () => {
    this.setState({ importButtonClicked: true });
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    this.uploadFile(this.state.moneyboxFile).then(file => {
      this.postMoneyboxImportTask(file);
    });
  };

  postMoneyboxImportTask = file => {
    this.setState({ isImporting: true });

    const data = {
      type: 'MONEY_BOX_CHANGE',
      file: file['@id'],
      config: {
        skipHeader: true,
        delimiter: ';',
      },
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    post('/importer-tasks', data).then(
      () => {
        this.setState({
          showMoneyboxModal: false,
          moneyboxFile: null,
          importButtonClicked: false,
        });
        this.setState({ isImporting: false });
        return toast.success(
          `${this.props.t('clients.moneyboxImportAdded')} ${this.props.t(
            'clients.refreshPage'
          )}`
        );
      },
      () => {
        this.setState({ isImporting: false });
        return toast.error(this.props.t('clients.moneyboxCannotImport'));
      }
    );
  };

  postImporterTask = file => {
    this.setState({ isImporting: true });
    const data = {
      type: 'CLIENTS',
      file: file['@id'],
      config: {
        skipHeader: true,
        delimiter: ';',
      },
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    post('/importer-tasks', data).then(
      () => {
        this.setState({
          openedModal: false,
          file: null,
          importButtonClicked: false,
        });
        this.setState({ isImporting: false });
        return toast.success(
          `${this.props.t('clients.importAdded')} ${this.props.t(
            'clients.refreshPage'
          )}`
        );
      },
      () => {
        this.setState({ isImporting: false });
        return toast.error(this.props.t('clients.cannotImport'));
      }
    );
  };

  // eslint-disable-next-line class-methods-use-this -- FIXME
  uploadFile = async file => {
    const data = new FormData();
    data.append('file', file);

    const response = await gastro.post('/media', data);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    return new Promise((resolve, reject) => {
      resolve(response.data);
    });
  };

  // eslint-disable-next-line class-methods-use-this -- FIXME
  getExampleMoneyboxImportFile(language) {
    switch (language) {
      case 'fi':
        return moneyboxCSVExampleFI;
      case 'en':
        return moneyboxCSVExampleEN;
      default:
        return moneyboxCSVExample;
    }
  }

  // eslint-disable-next-line consistent-return -- FIXME
  showInfo = () => {
    const activeUser = this.props.users.filter(
      user => user.hasActiveDiets === true
    );

    if (activeUser.length > 0) {
      const userId = activeUser.map(el => `${el.id}, `);

      return (
        <p>
          <Trans
            i18nKey="clients.massdelete.info"
            values={{ userId }}
            // eslint-disable-next-line react/jsx-key -- FIXME
            components={[<b />]}
          />
        </p>
      );
    }

    if (activeUser.length === 0 && !this.state.deleteAllCheckedClients) {
      this.setState(prevState => ({
        ...prevState,
        deleteAllCheckedClients: true,
      }));
    }
  };

  exportClientsToGoogleAds = () => {
    const fileName = 'client-google-ads';
    const endpoint = '/client-google-ads-export';
    const format = 'csv';
    const date = moment().format('DD-MM-YYYY_HH-mm');
    const exportedName = `${fileName}_${date}`;

    const params = {
      'order[id]': 'DESC',
      properties: [
        'email',
        'phone',
        'firstName',
        'lastName',
        'Country',
        'postCode',
      ],
    };

    axios
      .get(`${endpoint}.${format}`, {
        responseType: 'blob',
        params,
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${exportedName}.${format}`);

          document.body.appendChild(link);
          link.click();
          this.setState({ exporting: false });
        },
        () => {
          this.setState({ exporting: false });
          return toast.error(this.props.t('errors.dataExportFailed'));
        }
      );
  };

  render() {
    const {
      classes,
      t,
      i18n: { language },
    } = this.props;
    const defaultHiddenColumns = [];

    if (!this.state.isEmailConsentActive) {
      defaultHiddenColumns.push('emailConsent');
    }
    if (!this.state.isSmsConsentActive) {
      defaultHiddenColumns.push('smsConsent');
    }
    if (!this.state.isPhoneConsentActive) {
      defaultHiddenColumns.push('phoneConsent');
    }

    const customActions = () => [
      {
        component: ({ row }) => {
          if (!isGranted(ROLE_IMPERSONATE_USER) || isEmpty(row.homeDomain)) {
            return null;
          }

          return <FakeUserIcon email={row.email} domain={row.homeDomain} />;
        },
        type: 'customComponent',
      },
    ];
    return (
      <AdminTable title={t('clients.clientsList')}>
        <InfoModal
          modalState={this.state.openedModal}
          handleClose={() => this.toggleModal}
          modalContent={
            <div>
              <h1>{t('clients.clientsImport')}</h1>
              <p style={{ textAlign: 'left' }}>
                <ul>
                  <Trans
                    i18nKey="clients.importerModalInfo.marketingConsentSplit"
                    components={{
                      b: <b />,
                      li: <li />,
                      a: (
                        <a
                          href={getExampleImportFile(language)}
                          download={`${t(
                            'clients.importerModalInfo.fileName'
                          )}.csv`}
                        />
                      ),
                    }}
                  />
                </ul>
              </p>
              <MediaUpload
                file={this.state}
                setFile={file => this.setState({ file })}
                buttonText={t('clients.selectCSVFile')}
                addButtonProps={{
                  color: 'info',
                  round: false,
                }}
                changeButtonProps={{
                  color: 'info',
                  round: false,
                }}
                removeButtonProps={{
                  color: 'danger',
                  round: false,
                }}
              />
              <div>
                {isGranted(ROLE_CREATE_IMPORTER_TASK) &&
                  isGranted(ROLE_IMPORT_USER) && (
                    <Button
                      color={this.state.file ? 'success' : 'default'}
                      disabled={
                        !this.state.file ||
                        this.state.isImporting ||
                        this.state.importButtonClicked
                      }
                      onClick={this.importClients}
                    >
                      {t('clients.import')}
                    </Button>
                  )}
                <Button onClick={this.toggleModal}>{t('clients.close')}</Button>
              </div>
            </div>
          }
          closeButtonText={t('clients.close')}
          hideDefaultCloseButton={true}
        />

        <InfoModal
          modalState={this.state.showMoneyboxModal}
          handleClose={() => this.toggleMoneyboxModal}
          modalContent={
            <div>
              <h1>{t('clients.moneyboxModalHeader')}</h1>
              <p style={{ textAlign: 'left' }}>
                <ol
                  dangerouslySetInnerHTML={{
                    __html: t('clients.moneyboxModal', {
                      moneyboxCSVExample:
                        this.getExampleMoneyboxImportFile(language),
                      interpolation: { escapeValue: false },
                    }),
                  }}
                />
              </p>
              <MediaUpload
                file={this.state}
                setFile={file => this.setState({ moneyboxFile: file })}
                buttonText={t('clients.selectCSVFile')}
                addButtonProps={{
                  color: 'info',
                  round: false,
                }}
                changeButtonProps={{
                  color: 'info',
                  round: false,
                }}
                removeButtonProps={{
                  color: 'danger',
                  round: false,
                }}
              />
              <div>
                {isGranted(ROLE_CREATE_IMPORTER_TASK) &&
                  isGranted(ROLE_IMPORT_USER) && (
                    <Button
                      color={this.state.moneyboxFile ? 'success' : 'default'}
                      disabled={
                        !this.state.moneyboxFile ||
                        this.state.isImporting ||
                        this.state.importButtonClicked
                      }
                      onClick={this.importMoneyboxState}
                    >
                      {t('clients.import')}
                    </Button>
                  )}
                <Button onClick={this.toggleMoneyboxModal}>
                  {t('clients.close')}
                </Button>
              </div>
            </div>
          }
          closeButtonText={t('clients.close')}
          hideDefaultCloseButton={true}
        />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {isGranted(ROLE_SHOW_IMPORTER_TASK) &&
            isGranted(ROLE_IMPORT_USER) && (
              <Button
                style={{ margin: '5px', width: '158px' }}
                color="info"
                onClick={this.toggleModal}
              >
                {t('clients.importClients')}
              </Button>
            )}
          {isGranted(ROLE_SHOW_IMPORTER_TASK) &&
            isGranted(ROLE_IMPORT_USER) && (
              <Button
                style={{ margin: '5px', width: '300px' }}
                color="info"
                onClick={this.toggleMoneyboxModal}
              >
                {t('clients.moneyboxModalHeader')}
              </Button>
            )}
          {isGranted(ROLE_REMOVE_USER) && (
            <Button
              data-cy="__remove_dictionary_button"
              color="danger"
              onClick={() => {
                this.props.fetchUsers({
                  filtered: [{ id: 'id', value: this.state.checkedRowIds }],
                });

                this.setState({
                  isConfirmModalOpened: true,
                });
              }}
              disabled={this.state?.checkedRowIds?.length === 0}
            >
              {t('dictionary.deleteDictionaryElement')}
            </Button>
          )}
          {isGranted(ROLE_REMOVE_USER) && (
            <Button
              data-cy="__remove_dictionary_button"
              color="info"
              onClick={() => {
                this.exportClientsToGoogleAds();
              }}
            >
              {this.props.t('clients.export.googleAds')}
            </Button>
          )}
          {isGranted(ROLE_CREATE_USER) && (
            <FormControlButtons
              classes={classes}
              handleSubmit={this.newSize}
              submitText={`${this.props.t('clients.addClient')} +`}
            />
          )}
        </div>
        <DataGrid
          refresh={this.state.refreshList}
          massDelete={true}
          massDeleteItemsIds={this.state.checkedRowIds}
          massDeleteHandleSingleCheckbox={this.massDeleteHandleSingleCheckbox}
          massDeleteHandleMultipleCheckboxes={
            this.massDeleteHandleMultipleCheckboxes
          }
          refreshOnFetch={true}
          actions={true}
          editPath={`${window.location.pathname}/edit`}
          export={true}
          paginationTop={true}
          paginationBottom={false}
          url="/clients"
          reportName="client"
          columns={translateColumnConfig(
            t,
            this.props.sexes,
            this.state.clientTags,
            this.state.isEmailConsentActive,
            this.state.isSmsConsentActive,
            this.state.isPhoneConsentActive
          )}
          role="USER"
          customActions={customActions}
          customActionsWidth={150}
          customActionsColumnDirection="actions-left"
          canRemoveChecker={(canRemove, row) =>
            canRemove && !row.hasActiveDiets
          }
          defaultHiddenColumns={defaultHiddenColumns}
          manipulateQuery={(requestData, query) => {
            if (query.smsClientTags) {
              if (query.smsClientTags !== 'noTags') {
                query['smsClientTags.value'] = query.smsClientTags;
                query.smsClientTags = null;
              }
              if (query.smsClientTags === 'noTags') {
                query['exists[smsClientTags]'] = false;
                query.smsClientTags = null;
              }
            }

            if (query.gender) {
              query['gender[]'] = query.gender;
              query['gender[_operator]'] = 'eq';
            }
            if (query.createdAt) {
              const filters = query.createdAt;
              delete query.createdAt;
              if (filters.after) {
                query['createdAt[after]'] = filters.after;
              }
              if (filters.before) {
                query['createdAt[before]'] = filters.before;
              }
            }

            if (query.firstName) {
              const splicedName = query.firstName.split(' ');
              // eslint-disable-next-line no-underscore-dangle -- FIXME
              const _andX = [
                [
                  {
                    firstName: splicedName[0],
                    lastName: splicedName[0],
                  },
                ],
              ];

              if (splicedName.length > 1) {
                _andX[0][0].lastName = splicedName[1];
              }

              const operator = splicedName.length > 1 ? '_andX' : '_orX';

              delete query.firstName;
              query[operator] = _andX;
            }

            query.type = 'CLIENT';

            return query;
          }}
        />

        <Dialog fullWidth={true} open={this.state.isConfirmModalOpened}>
          <SweetAlert
            warning={true}
            style={{ display: 'block' }}
            title={t('common.shared.areYouSure')}
            onConfirm={this.massDeleteSubmit}
            onCancel={() =>
              this.setState(prevState => ({
                ...prevState,
                isConfirmModalOpened: !prevState.isConfirmModalOpened,
              }))
            }
            confirmBtnCssClass={`${classes.button} ${classes.success}`}
            cancelBtnCssClass={`${classes.button} ${classes.danger}`}
            confirmBtnText={t('common.shared.yes')}
            cancelBtnText={t('common.shared.no')}
            showCancel={true}
          >
            {this.state.isConfirmModalOpened ? this.showInfo() : null}
          </SweetAlert>
        </Dialog>
      </AdminTable>
    );
  }
}

const mapStateToProps = state => ({
  brands: state.Brands.brandsList,
  currentBrand: state.Brands.brand,
  auth: state.Auth,
  sexes: state.Dictionary.sexes,
  users: state.Users.users,
});

const mapDispatchToProps = {
  fetchBrandsList,
  fetchSexes,
  fetchUsers,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(buttonsStyle),
  withTranslation()
);

export default enhance(List);
